import { Box, Typography, Tooltip, IconButton } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import UnarchiveIcon from '@mui/icons-material/Unarchive';

interface HeapDetailsHeaderInfoBarProps {
  overallDetectionsCount: number;
  recordedAt: Date;
  licensePlate?: string;
  archived: boolean;
  onArchiveClick: () => void;
}

export function HeapDetailsHeaderInfoBar({
  overallDetectionsCount,
  recordedAt,
  licensePlate,
  archived,
  onArchiveClick,
}: HeapDetailsHeaderInfoBarProps): ReactElement {
  const { t } = useTranslation();

  return (
    <Box
      flexShrink={0}
      sx={{
        display: 'flex',
        flexWrap: 'wrap',

        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 1,
        marginTop: -2,
        borderBottom: '1px solid #e0e0e0',
      }}
    >
      <Box display='flex' alignItems='center' gap={1}>
        <CalendarTodayIcon
          fontSize='small'
          sx={{
            mt: 0.25,
          }}
        />
        <Typography>
          {t('common.intlDateTime', {
            val: recordedAt,
            formatParams: { val: { dateStyle: 'medium', timeStyle: 'short' } },
          })}
        </Typography>
      </Box>

      {licensePlate && (
        <Box display='flex' alignItems='center' gap={1}>
          <LocalShippingIcon
            fontSize='small'
            sx={{
              mt: 0.25,
            }}
          />
          <Typography>{licensePlate}</Typography>
        </Box>
      )}

      <Box display='flex' alignItems='center' gap={1}>
        <Typography>
          {overallDetectionsCount} {t('heap.detections')}
        </Typography>
      </Box>

      <Tooltip title={archived ? t('heap.unarchive') : t('heap.archive')}>
        <IconButton onClick={onArchiveClick} size='small' color='primary'>
          {archived ? <UnarchiveIcon /> : <DeleteIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
